import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseControlDirective } from 'app/shared/directives/control/base-control.directive';

@Component({
  selector: 'kh-common-checkbox',
  templateUrl: './common-checkbox.component.html',
  styleUrls: ['./common-checkbox.component.less'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CommonCheckboxComponent),
    multi: true
  }],
  standalone: false
})

export class CommonCheckboxComponent extends BaseControlDirective<boolean> {
  @Input() public id = 'common-checkbox';
  @Input() public isClickableLabel = false;
}
